export default "/assets/website/images/csoki.png?a51f07fb385c3d3931566713e39a37b4";